import api from '../api';
import { DateTime } from "luxon";

const END_POINT = "/api/intervention-memento";

/**
 * This method will load memento depending of page, size parameters with a get http call
 * 
 * @param  {int} page page number that will be load
 * @param  {int} size number of memento that will be load (represents LIMIT in sql)
 * @returns {} it is returning a promise with all memento
 */
export async function getAllIMementoHttp(page, size) {
    return await api.get(`${END_POINT}/${page}/${size}`);
}

/**
 * This method will give the number of all memento in the database with a get http call
 * 
 * @returns {} it is returning a promise with the number of memento
 */
export async function getIMementoCountHttp() {
    return await api.get(`${END_POINT}/count`);
}

/**
 * This method will give the selected memento
 * 
 * @param  {long} id id of the memento we want to select
 * @returns {} it is returning a promise with the selected memento
 */
export async function getIMementoByIdHttp(id) {
    return await api.get(`${END_POINT}/${id}`);
}

/**
 * This method will give the previous intervention state before the selected memento
 * 
 * @param  {long} interventionId id of the intervention present in the selected memento
 * @param  {long} interventionMementoId id of the selected memento
 * @returns {} it is returning a promise with the previous intervention state before the selected memento
 */
export async function getIMementoLastBeforeHttp(interventionId, interventionMementoId) {
  return await api.get(`${END_POINT}/last-before`, {
    params: { 
      interventionId: interventionId,
      interventionMementoId: interventionMementoId
    }
  });
}

/**
 * This method will load memento depending of page, size, dateStart and dateEnd parameters with a get http call
 * 
 * @param  {long} id id of the intervention we want to see previous states
 * @param  {String} dateStart select memento from this date
 * @param  {String} dateEnd select memento until this date
 * @param  {int} page page number that will be load
 * @param  {int} size number of memento that will be load (represents LIMIT in sql)
 * @returns {} it is returning a promise with memento depending of parameters selected
 */
export async function filterIMementoHttp(id, dateStart, dateEnd, page, size) {
  let start = new DateTime.fromISO(dateStart).toFormat('yyyy-MM-dd HH:mm');
  let end = new DateTime.fromISO(dateEnd).plus({ hours: 24 }).toFormat('yyyy-MM-dd HH:mm');
  return await api.get(`${END_POINT}/filter/${id}`, {
    params: { 
      start: start,
      end: end,
      page: page,
      size: size,
    }
  });
}

/**
 * This method will give the number of all memento depending of parameters selected in the database with a get http call
 * 
 * @param  {long} id id of the intervention we want to see previous states
 * @param  {String} dateStart select memento from this date
 * @param  {String} dateEnd select memento until this date
 * @returns {} it is returning a promise with the number of memento
 */
export async function getIMementoFilterCountHttp(id, dateStart, dateEnd) {
  let start = new DateTime.fromISO(dateStart).toFormat('yyyy-MM-dd HH:mm');
  let end = new DateTime.fromISO(dateEnd).plus({ hours: 24 }).toFormat('yyyy-MM-dd HH:mm');
  return await api.get(`${END_POINT}/count-filter`, {
    params: { 
      interventionId: id,
      start: start,
      end: end,
    }
  });
}

/**
 * This method will replace the current state of an intervention with a selected previous state
 * 
 * @param  {long} id id of the selected memento that we want to restore
 * @returns {} it is returning a promise. You will have 202 status if the previous intervention was restored successfully.
 */
export async function restoreByIdHttp(id) {
    return await api.get(`${END_POINT}/restore/${id}`, {
    });
}

/**
 * This method will download a CSV file with the list of memento between the two selected dates
 * 
 * @param  {String} dateStart select memento from this date
 * @param  {String} dateEnd select memento until this date
 * @returns {} it is returning a promise
 */
export async function downloadMementoHtpp(dateStart, dateEnd) {
  return await api.get(`${END_POINT}/export-csv-dates`,
    { 
      params: { 
      dateStart: dateStart,
      dateEnd: dateEnd,
      }
    }
  );
}